import React from "react";
import FeatureBox from "./FeatureBox";
import FeatureImage1 from "../images/feature_2.png";
import FeatureImage2 from "../images/feature_3.png";
import FeatureImage3 from "../images/feature_1.png";

function Feature(){
    return(
    <div id="features">
        <div className="a-container">
            <FeatureBox image={FeatureImage1} title='Frontend'/>
            <FeatureBox image={FeatureImage2} title='Serverend'/>
            <FeatureBox image={FeatureImage3} title='Backend'
        /></div>
    </div>
    )
}
export default Feature;